
import React from 'react'
import logo from "../../assets/SMARTLEND.png"
const Logo = () => {
  return <img src={logo} alt="smartlend logo" />
}

export default Logo
